<template>
  <div class="m-container">
    <m_header></m_header>
    <m_menu></m_menu>
    <div class="m-body">
      <el-container class="m-title-box">
        <div class="m-title">
          <div class="m-title-t">创业诊断信息管理</div>
          <span class="m-title-s">创业诊断选项信息新增、编辑等操作</span>
        </div>
        <div class="m-tips">
          <i class="el-icon-warning"></i>使用提示
        </div>
      </el-container>
      <div class="m-table">
        <el-container class="m-table-head">
          <div class="m-table-title">
            <i class="el-icon-s-opportunity"></i>信息列表
          </div>
          <div class="m-table-btn">
<!--            <el-button @click="openPopup" type="primary" size="">新增诊断信息</el-button>-->
          </div>
        </el-container>
        <el-table :data="list" v-loading="isLoading" style="width: 100%;margin-bottom: 20px;" border>
          <el-table-column prop="title" label="标题" width=""></el-table-column>
          <el-table-column prop="quotaMax" label="每日上限" width="" align="center"></el-table-column>
<!--          <el-table-column prop="quotaNumber" label="今日剩余" width="110" align="center"></el-table-column>-->
          <el-table-column prop="money" label="诊断价格" width="110" align="center"></el-table-column>
          <el-table-column prop="createDate" label="创建时间" width="110" align="center"></el-table-column>
          <el-table-column prop="updateDate" label="修改时间" width="110" align="center"></el-table-column>
          <el-table-column prop="remarks" label="备注" align="center"></el-table-column>
          <el-table-column label="操作" width="160" align="center">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="openForm(scope.row)" plain>编辑</el-button>
<!--              <el-button type="danger" size="mini" @click="thisDel(scope.row.id)" plain>删除</el-button>-->
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog :title="openText" :visible.sync="openState" @close='closeDialog' width="750px" center :close-on-click-modal="false">
      <div class="m-open-container" v-loading="formLoading">
        <div class="zs-open-body-ov">
          <el-form :model="form" :rules="rules" ref="form" label-width="125px">
            <el-form-item label="诊断标题: " prop="title">
              <el-input v-model="form.title" placeholder="输入诊断标题"></el-input>
            </el-form-item>
            <el-form-item label="每日上限: " prop="quotaMax">
              <el-input v-model="form.quotaMax" placeholder="输入每日上限"></el-input>
            </el-form-item>
<!--            <el-form-item label="今日剩余: " prop="quotaNumber">-->
<!--              <el-input v-model="form.quotaNumber" placeholder="输入今日剩余"></el-input>-->
<!--            </el-form-item>-->
            <el-form-item label="诊断价格: " prop="money">
              <el-input v-model="form.money" placeholder="输入诊断价格"></el-input>
            </el-form-item>
            <el-form-item label="备注: " prop="remarks">
              <el-input v-model="form.remarks" type="textarea" :rows="2" placeholder="输入备注"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-foote" style="text-align: center;">
          <el-button @click="openState = false">取 消</el-button>
          <el-button type="primary" @click="submit()">确 定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: 'doctorInfo',
  data () {
    return {
      openText: '新增',
      openState: false,
      formLoading: false,
      isLoading: false,
      list: [],
      form: {
        id: '',
        title: '',
        quotaMax: '',
        quotaNumber: '',
        money: '',
        remarks: '',
        createDate: '',
        updateDate: ''
      },
      rules: {
        title: [
          {required: true, message: '请输入标题', trigger: 'blur'}
        ],
        quotaMax: [
          {required: true, message: '请输入每日上限', trigger: 'blur'}
        ],
        quotaNumber: [
          {required: true, message: '请输入今日剩余', trigger: 'blur'}
        ],
        money: [
          {required: true, message: '请输入价格', trigger: 'blur'}
        ]
      }
    }
  },
  methods: {
    audioDuration (e) {
      this.form.duration = e.duration
    },
    closeDialog: function () {
      this.form = {
        id: '',
        title: '',
        quotaMax: '',
        quotaNumber: '',
        money: '',
        remarks: '',
        createDate: '',
        updateDate: ''
      }
      this.openText = '新增'
      this.formLoading = false
    },
    openPopup () {
      this.openState = true
    },
    submit () {
      let _this = this
      this.$refs['form'].validate((valid) => {
        if (valid) {
          _this.formLoading = true
          this.$axios.post('/doctor/info/save', _this.form)
            .then((res) => {
              if (res.status === 200) {
                _this.$message.success(res.msg)
                _this.loadData()
                _this.openState = false
                _this.formLoading = false
              } else {
                _this.$message.error(res.msg)
              }
            })
        } else {
          return false
        }
      })
    },
    // thisDel (id) {
    //   let _this = this
    //   this.$messageBox.confirm('此操作将永久删除当前项, 是否继续?', '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     type: 'error'
    //   }).then(() => {
    //     this.$axios.post('/admin/secretDel', {id: id})
    //       .then((res) => {
    //         if (res.code === 200) {
    //           _this.$message({
    //             type: 'success',
    //             duration: '800',
    //             message: res.msg,
    //             onClose: function () {
    //               _this.listData()
    //             }
    //           })
    //         } else {
    //           _this.$message({
    //             type: 'error',
    //             duration: '800',
    //             message: res.msg
    //           })
    //         }
    //       })
    //   }).catch(() => {
    //     this.$message({
    //       type: 'info',
    //       message: '已取消删除'
    //     })
    //   })
    // },
    openForm (row) {
      this.openText = '编辑'
      this.form = row
      this.openState = true
    },
    // 管理员列表
    loadData () {
      let _this = this
      this.isLoading = true
      _this.list = []
      this.$axios.post('/doctor/info/list')
        .then((res) => {
          _this.list = res.data
          _this.isLoading = false
        })
    }
  },
  mounted () {
    this.loadData()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/doctor/DoctorInfo.vue